import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorTechniquesComponent } from './error-techniques/error-techniques.component';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { AutoComponent } from './MiAuto/auto/auto.component';
import { SeguroComponent } from './MiSeguro/seguro/seguro.component';
import { EventosComponent } from './MisEventos/eventos/eventos.component';
import { ViajesComponent } from './MisViajes/viajes/viajes.component';

const routes: Routes = [
  { path : 'landing',   component : LandingComponent },
  { path : '',
    component : HomeComponent,
    children: [
      { path : '', redirectTo: '/seguro', pathMatch: 'full' },
      { path : 'seguro', component : SeguroComponent },
      { path : 'seguro/:poliza', component : SeguroComponent },
      { path : 'viajes', component : ViajesComponent },
      { path : 'eventos', component: EventosComponent },
      { path : 'auto', component: AutoComponent}
    ]},
  { path : 'error',   component : ErrorComponent },
  { path : 'errortechniques', component: ErrorTechniquesComponent },
  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
